
import {
  deviceDefaultSetting,
  defaultLocationData,
} from '@bingads-webui-campaign/hotel-common-targets';
import { audienceAdsOptionKeys, defaultAdFormat } from '@bingads-webui-campaign/hotel-common-upsert';
import { defaultName } from '@bingads-webui-campaign-react/wizard-shared-components';
import { defaultBidStrategy } from './bid-strategy';
import { defaultBudget } from './budget';

const fields = {
  name: 'name',
  budget: 'budget',
  bidStrategy: 'bidStrategy',
  device: 'device',
  location: 'location',
  adSchedule: 'adSchedule',
  adFormat: 'adFormat',
  audienceAds: 'audienceAds',
};

const {
  name,
  budget,
  bidStrategy,
  device,
  location,
  adSchedule,
  adFormat,
  audienceAds,
} = fields;

export const fieldsToCheck = [adSchedule, audienceAds, name, budget, bidStrategy, device, location, adFormat];

export const defaultCampaignBasicData = {
  name: {
    value: defaultName,
  },
  adFormat: defaultAdFormat,
  budget: defaultBudget,
  bidStrategy: defaultBidStrategy,
  audienceAds: {
    parentLevelSettings: {},
    currentLevelSettings: { option: audienceAdsOptionKeys.Increase, value: 0 },
    useParentLevel: false,
  },
  dayTimeRanges: [],
  urlOptions: {},
  location: defaultLocationData,
  exclusions: {},
  device: {
    parentLevelSettings: [...deviceDefaultSetting],
    currentLevelSettings: [...deviceDefaultSetting],
    useParentLevel: false,
  },
};
